import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";
import TableContainerSearch2 from "../../Components/Common/TableContainerSearch2";
import TableContainer1 from "../../Components/Common/TableContainer1";
import axios from "axios";
import exportToPDF from "../../Components/Common/exportToPDF";

import exportToExcel from "../../Components/Common/exportToExcel";
import { useDispatch } from "react-redux";
import { showToast } from "../../Components/ToastNotification";
import { contractNote_singleThunk, shareEmailReportThunk } from "../../slices/thunks";
import CommonLoading from "../../Components/Common/CommonLoading";
import TableContainerDateRangeFilter6 from "../../Components/Common/TableContainerDateRangeFilter6";
import ContractNoteModal from "../../Components/Modals/ContractNoteModal";
import { useSelector } from "react-redux";

const ContractNote = () => {
  // document.title = "Dashboard | B.N. Rathi";

  const { userData } = usePersistStoreData();
  const dispatch = useDispatch();
  const token = userData?.token;
  const [dateRange, setDateRange] = useState([]);
  const [exchangeFilter, setExchangeFilter] = useState("");
  const [rightColumn, setRightColumn] = useState(true);
  const [allDownloadLoading, setAllDownloadLoading] = useState(false); 
  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };
  const [isTopPageDropdown, setTopPageDropdown] = useState(false);
  const toggleDropdown = () => {
    setTopPageDropdown(!isTopPageDropdown);
  };

  const [showModal, setShowModal] = useState(true);
  const onCloseClick = () => {
      setShowModal(false);
  };

  const columns = useMemo(
    () => [
      { id: "trade_date", Header: "Trade Date", accessorKey: "trade_date" },
      { id: "contract_note_no", Header: "Contract Note No.", accessorKey: "contract_note_no" },
      { id: "trade_type", Header: "Trade Type", accessorKey: "trade_type" },
     
      {
        id: "action",
        Header: "Actions",
        accessorKey: "action",
        cell: ({ row }) => (
          <button
            className="btn btn-sm btn-primary"
            onClick={() => handleActionClick(row.original)}
          >
            Download
          </button>
        ),
      },
     
    ],
    []
  );

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [expense, setExpense] = useState(null);
  const [loading, setLoading] = useState(false);
  const [exchange, setEchange] = useState("");
  const [error, setError] = useState(null);
  const yesterdayDate = new Date();
  yesterdayDate.setDate(yesterdayDate.getDate() - 1);

  const [selectedDate, setSelectedDate] = useState(yesterdayDate);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  

  const { contractNote_listData, contractNote_listLoading } = useSelector(
    (state) => state.ContractNote_List
  );

  const { contractNote_singleMessage, contractNote_singleLoading } = useSelector(
    (state) => state.ContractNote_Single
  );

 

  const tableHeaders = columns.map((col) => col.Header.replace(/₹/g, "Rs"));
  const tableBody = data.map(
    (row) =>
      columns.map((col) =>
        row[col.accessorKey]
          ? typeof row[col.accessorKey] === "string"
            ? row[col.accessorKey]
            : row[col.accessorKey].toLocaleString("en-IN")
          : 0
      ) // Default to 0 if value is missing
  );

  // Define which columns to sum
  const sumColumns = ["debit", "credit"];
  // Example API response for totals
  const apiTotals = {
    debit: summary?.total_debit ?? 0, // Replace with actual API data
    credit: summary?.total_credit ?? 0,
  };

  // Insert API totals only for "debit" and "credit"
  const totals = columns.map((col, index) => {
    if (index === 0) return "Total"; // First column will have "Total"

    return sumColumns.includes(col.accessorKey)
      ? apiTotals[col.accessorKey]?.toLocaleString("en-IN") || 0 // Use API total, default to 0 if missing
      : ""; // Leave other columns empty
  });

  

  // Add totals row to the ta
  tableBody.push(totals);

  const convertToDateFormatYMD = (dateString) => {
    const months = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };

    const [day, month, year] = dateString.replace(",", "").split(" ");
    return `${year}-${months[month]}-${day.padStart(2, "0")}`;
  };

  const handleAllDownload = async () => {
    try {
      setAllDownloadLoading(true); // Start loading
  
      const contractNames = {};
      const items = contractNote_listData?.items || {};
  
      Object.keys(items).forEach((date) => {
        contractNames[`contract_names[${date}]`] = items[date];
      });
  
      const params = {
        contract_type: contractNote_listData?.summary?.contract_type,
        download_type: "range",
        start_date: convertToDateFormatYMD(contractNote_listData?.summary?.start),
        end_date: convertToDateFormatYMD(contractNote_listData?.summary?.end),
        ...contractNames,
      };
  
      const response = await axios.get("/contract-notes/download", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      });
  
      // Show success toast using message from API
      showToast(response?.message || "Download started", "success");
  
    } catch (error) {
      const errorMessage =
        error?.response?.message || "Something went wrong. Please try again later";
      showToast(errorMessage, "error");
      console.error("Download error:", error);
    } finally {
      setAllDownloadLoading(false); // End loading
    }
  };

  return (
    <React.Fragment>
      {!showModal ? (
         <div className="page-content">
         <Container fluid>
           {loading ? (
             <div
               className="centerContent h-100 w-100"
               style={{ minHeight: "80vh" }}
             >
               <CommonLoading />
             </div>
           ) : (
             <Card className="mb-6">
               <CardHeader>
                 <div className="m-0 p-0 d-flex align-items-center justify-content-between">
                   <h3 className="m-0">Contract Note</h3>
                   {contractNote_listData?.items && Object.keys(contractNote_listData.items)?.length > 0 && (
                     <Dropdown
                     isOpen={isTopPageDropdown}
                     toggle={toggleDropdown}
                     className="card-header-dropdown"
                   >
                     <DropdownToggle
                       tag="a"
                       className="text-reset dropdown-btn"
                       role="button"
                       color="success"
                     >
                       <Button type="button" color="success"
                       onClick={handleAllDownload}
                       style={{
                        minWidth:"150px"
                       }}
                       disabled={allDownloadLoading}
                       >
                        {allDownloadLoading ? (
                          <Spinner size="sm"
                          
                          />
                        ) : (
                          <>
                          Download All<i className='bx bx-download fs-16 ms-2 '></i>
                          </>

                        )}
                        
                       </Button>
                     </DropdownToggle>
                    
                   </Dropdown>
                   )}
                  
                 </div>
               </CardHeader>
               <CardBody>
                 <TableContainerDateRangeFilter6
                   
                   summary={summary}
                  //  columns={columns}
                   data={data}
                  
 
                 />
               </CardBody>
             </Card>
           )}
         </Container>
       </div>
      ): null}
     
      {showModal && (
        <ContractNoteModal
          showModal={showModal}
          onCloseClick={onCloseClick}
        />
      )}
    </React.Fragment>
  );
};

export default ContractNote;
